import React from 'react'

const Overlay = ({ visible, children }) => {
  return (
    <div
      className="bg-white"
      style={{ transition: 'opacity 0.25s', opacity: visible ? 0.5 : 1 }}
    >
      {children}
    </div>
  )
}

export default Overlay
